// extracted by mini-css-extract-plugin
export default {"outer":"LeadingVisual-module__outer--qS9Ac","inner":"LeadingVisual-module__inner--GeEeG"};